import React from 'react'

const CircleGraph = ({segments}) => {

    // const segments = [
    //     {
    //         name: 'loan',
    //         percentage: 70,
    //     },
    //     {
    //         name: 'tax',
    //         percentage: 30,
    //     },
    // ]

    const getSegments = () => {
        let offset = 0;
        const segmentHTML = []

        segments.forEach((segment, i) => {
            const calced = calc(segment.percentage, offset);
            segmentHTML.push(`<circle class="graph-segment ${segment.name}" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke-width="3" stroke-dasharray="${calced.array}" stroke-dashoffset="${calced.dashoffset}"></circle>`)
            offset += segment.percentage;
        });

        return segmentHTML.join('');
    }

    const getSVG = () => {

        return `
            <!--<circle class="graph-hole" cx="21" cy="21" r="15.91549430918954" fill="#eee"></circle>-->
            <circle class="graph-ring" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#ddd" stroke-width="3"></circle>
            ${getSegments()}
        `
    }

    const calc = (percentage, offset)=>{
        const array = [percentage, (100 - percentage)].join(' ');
        const dashoffset = 25 + (100 -offset)

        return {
            array,
            dashoffset
        }
    }

    return (
        <svg  
            width="100%" 
            height="100%" 
            viewBox="0 0 42 42" 
            className="cost-graph" 
            dangerouslySetInnerHTML={{ __html: getSVG() }}>
        </svg>
    )

}

export default CircleGraph